import { Component, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';

const unhRoot = document.querySelector('unh-root');

@Component({
  selector: 'unh-filter-bottomsheet',
  templateUrl: './filter-bottomsheet.component.html',
  styleUrls: ['./filter-bottomsheet.component.scss'],
})
export class FilterBottomsheetComponent implements OnInit, OnDestroy {
  constructor(private renderer: Renderer2) {}

  @Input() isAutoHeight: number;

  ngOnInit(): void {
    this.renderer.setStyle(unhRoot, 'overflow', 'hidden');
  }

  ngOnDestroy(): void {
    this.renderer.setStyle(unhRoot, 'overflow', 'visible');
  }
}
